import { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import ActivityIndicator from "../components/ActivityIndicator";
import LayoutApp from "../components/Layout";

interface PrivateRouteProps {
  children: JSX.Element;
}

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { isLoading, token } = useAuth();

  if (isLoading) {
    return <ActivityIndicator />;
  } else if (token) {
    return <LayoutApp>{children}</LayoutApp>;
  } else {
    return <Navigate to="/login" replace />;
  }
};
